module.exports = __webpack_public_path__ + "static/media/pagos360.fa5885a3.png";